import AccountsCard from "@/components/_module/withdraw/card/allAccounts";
import ConnectAccountCard from "@/components/_module/withdraw/card/connectAccount";
import { useNavigate, useLoaderData } from "@tanstack/react-router";
import { CircleHelp, InfoIcon, XIcon } from "lucide-react";
import { useAuth } from "@/context/auth-context";
import useGetBankAccounts from "@/features/bank-accounts/useGetBankAccounts";
import { AccountBalanceDisplay } from "@/components/ui/accountBalanceDisplay/accountBalanceDisplay";
import { getHelpCenterUrl } from "@/lib/utils";
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "@/components/ui/popover";

const WithdrawPage = () => {
	const navigate = useNavigate();
	const { user } = useAuth();
	const { location_id, name } = useLoaderData({ from: "__root__" });
	const { data: bankAccounts } = useGetBankAccounts({
		guestId: user.id,
		locationId: location_id,
	});

	return (
		<div className="flex flex-col items-center px-6 py-8 bg-white text-textDark">
			<div className="relative flex w-full">
				<XIcon
					className="absolute right-0 -top-2"
					role="button"
					onClick={() =>
						navigate({
							to: "/main/card",
						})
					}
				/>
			</div>
			<h1 className="mt-2 text-4xl font-bold text-textDark">Move Money</h1>
			<AccountBalanceDisplay
				className="mt-6 text-2xl font-bold text-center text-textDark"
				errorClassName="mt-6"
				loadingClassName="text-textDark mt-6"
			/>
			<div className="flex items-center justify-center gap-1 mb-4 text-sm text-gray-500">
				<p className="text-lg text-textLight">Available for transfer</p>
				<Popover>
					<PopoverTrigger>
						<InfoIcon className="w-4 h-4" />
					</PopoverTrigger>
					<PopoverContent align="center" className="">
						<div className="max-w-xs p-4 text-sm text-gray-800">
							The total amount in your {name} account available for transfers
							and transactions.
						</div>
					</PopoverContent>
				</Popover>
			</div>
			{bankAccounts ? (
				bankAccounts.length <= 0 ? (
					<ConnectAccountCard />
				) : (
					<AccountsCard accounts={bankAccounts} />
				)
			) : (
				<></>
			)}

			{/* <h2 className="my-6 text-2xl font-bold text-center text-textDark">
				More ways to send
			</h2>
			<div className="space-y-3">
				<OtherWayCard
					name="Wire or ACH"
					last4="Transfer directly from Kashu"
					Icon={<DollarSendIcon />}
				/>
				<OtherWayCard
					name="Push to Card"
					last4="Send funds to credit/debit card"
					Icon={<AddCreditCardIcon />}
				/>
			</div> */}
			<a
				href={getHelpCenterUrl()}
				target="_blank"
				rel="noopener noreferrer"
				className="flex items-center justify-center gap-2 py-8"
			>
				<CircleHelp className="w-5 h-5 text-textDark" />
				<span className="text-textDark">Need Help?</span>{" "}
				<span className="text-textDark font-semibold">Talk to support</span>
			</a>
		</div>
	);
};
export default WithdrawPage;
